import { useThankProps } from './types'
import ThanxView from './views/ThanxView'
import useThanx from './hooks/useThanx'
import { wrap } from '../../utils/globalUtils'

const Thanx: React.FC<useThankProps> = wrap(ThanxView, useThanx)
export default Thanx
